import { useRef } from "@max/max";
export function useLoopNumRef(options) {
    const { size, reverse = false, init = reverse ? size - 1 : 0 } = options;
    const currentNum = useRef(init);
    function next(steps = 1) {
        const _ = reverse ? currentNum.current - steps + size : currentNum.current + steps + size;
        currentNum.current = Math.abs(_ % size);
    }
    return [currentNum, next];
}
